export const state = {
    width: window.innerWidth,
    height: window.innerHeight
}